import React, {useState} from 'react'
import { useContext } from 'react'
import AuthContext from './AuthContext';
//import { Redirect } from 'react-router-dom'
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import Axios from 'axios';

const Login = ({handlelogin}) => {

  //455693930

  const [showPassword, setShowPassword] = useState(false);

  const [inpuserpass,setinpuserpass] = useState({
    userid: '',
    password: '',
    lang: ''
  });


  //let {tidcon} = useContext(AuthContext);
  //const {isLoggedIn,setisLoggedIn} = useContext(AuthContext);
  const {setisLoggedIn} = useContext(AuthContext);  
  const {settoken} = useContext(AuthContext);
  const {setgcusername} = useContext(AuthContext);  
  const {setgnuserid} = useContext(AuthContext);  
    
  const {gclang,setgclang} = useContext(AuthContext);

  const [txthandleerror,settxthandleerror] = useState('')


  
  const history = useHistory();

//   if(!isLoggedIn) {
//     return  <Redirect to="/" />

// }


  const handletxtonchange = (e) => {
    e.preventDefault(); 
   
    const fieldName = e.target.getAttribute('name');
    const fieldValue = e.target.value;

    const newFormData = {...inpuserpass }; 
    newFormData[fieldName] = fieldValue; 
    
    if(gclang === 'th'){
      newFormData["lang"] = '1';  
    }
    else if (gclang === 'en'){
      newFormData["lang"] = '2';  
    }
    setinpuserpass(newFormData);
    


  }

  async function fn_login(e) {
      e.preventDefault(); 

      //console.log(inpuserpass);
      
      const response = await Axios.post("/login" , inpuserpass);
      

      // const response = await Axios.post('/login',{       
      //   //name:'admin',
      //   //password:'admin',
      //   'withCredentials': false,     
      //   headers:{
      //       "x-access-token": "",
      //       'Cache-Control': 'no-cache',
      //       'Pragma': 'no-cache',
      //       'Expires': '0',        
      //     }});


      // console.log(response.data);           
      // console.log(response.data.token);
      // console.log(response.data.username);

      let output = response.data; 
      console.log(output);
      
      if(output.username === '' && output.userid === 0) { 
        settxthandleerror((a) => (`Username or Password are not correct`));                 
      }
      else{
        if(output.length > 0){           
          setgnuserid((b) => (output[0].userid));
          setgcusername((a) => (output[0].username));
          settoken((a) => (output[0].token));
          setisLoggedIn((a) => (true));  //login success
          /* tidtidtid
          const mylang = output[0].lang === "1" ? "th" : "en";
          console.log(mylang);
          setgclang((a) => (mylang));           
          ////history.push('/home');
          if(mylang === 'th'){
            history.push('/home');
          }
          else if (mylang === 'en'){
            history.push('/home_en');
          }
          */

          if(gclang === 'th'){
            history.push('/home');
          }
          else if (gclang === 'en'){
            history.push('/home_en');
          }

          ////handlelogin(`${output[0].userid} ${output[0].username} Logout`); // change status for logout to press quit system           
          handlelogin(`${output[0].userid} Logout`); // change status for logout to press quit system           
        }
        else
        {
          settxthandleerror((a) => (`${output.msg}`));                 
          
        }

      }
      

      /* change return one recordset to many recordsets
      if(response.data.username === ''){
        settxthandleerror((a) => (`Having Error: ${response.data.token}`));        
        console.log("Having Error ",response.data.token);
      }
      else {

        setgnuserid((b) => (response.data.userid));
        setgcusername((a) => (response.data.username));
        settoken((a) => (response.data.token));
        setisLoggedIn((a) => (true));  //login success
        history.push('/home');
        handlelogin(`${response.data.username} Logout`); // change status for logout to press quit system 

      }
       */    
      


      // async function fetchData() {
      //   const response = await Axios.get("/test3");       
      //   setmydata(response.data);                      
      // }
      
      // Axios.get("http://localhost:3001/test2").then( (response) => {            
      //   console.log(response);            
      // }); 


      // Axios.post("/fn_test2?username=flask").then( (response) => {        
      //   console.log(response);        
      // });

      // Axios.post("http://localhost:3001/create" , {
      //   name:name,
      //   addr:addr2
      // }).then( (response) => {    
      //   console.log(response);                    
      // })

      // var  x = [{name:"zero",addr:"1/13"},{name:"mono",addr:"999999999/99999"}];         
      // Axios.post("http://localhost:3001/create2" , x).then( (response) => {    
      //   console.log(response);          
      // })

      
      // const handleAxiosIndex = () => {
      //   Axios.get('http://localhost:3001',{'withCredentials': true}).then( (response) => {        
      //       localStorage.setItem("token",response.data.token);
      //       console.log(response);  
      //   });
      // }

      // const handleAxiosHome = () => {    
      //   Axios.get('http://localhost:3001/home',{    
      //   'withCredentials': true,     
      //   headers:{
      //       "x-access-token": localStorage.getItem("token"),
      //       'Cache-Control': 'no-cache',
      //       'Pragma': 'no-cache',
      //       'Expires': '0',        
      //     }}).then( (response) => {
      //       console.log(response);           
      //   });
      // } 

  }
   

  return (
    <div className="container-fluid">
    <div className="row align-items-center mt-5">
      <div className="col-sm-4">         
      </div>
      
      <div className="col-sm-4">
      <div className="card">
      <h4>
      <div className="card-header bg-secondary">
      {/* <center>Login CBS</center>   */}
      {/* <center><span class="text-white">Login Form</span></center> */}
      <span class="text-white"><i class="fa fa-lock" aria-hidden="true"></i>&nbsp;&nbsp;Login Form</span>
      </div></h4>
      
      <div className="card-body">
        <form method="post" autocomplete="off" onSubmit={fn_login}>
        <div className="input-group mb-3">
                {/* <div class="input-group-text">
                   
                </div> */}
                <input type="text" placeholder="เลขประจำตัวประชาชน ID/Passport No:"  id="userid" name="userid" className="form-control" onChange={handletxtonchange}  autofocus="autofocus" required />            
        </div> 


        <div className="input-group mb-3">
                {/* <div className="input-group-text">
                   
                </div> */}
                {/* <input type="password" placeholder="Password:"  id="password" name="password" className="form-control" onChange={handletxtonchange}  autofocus="autofocus" required />  */}
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password:"
                  id="password"
                  name="password"
                  className="form-control"
                  onChange={handletxtonchange}
                  autoFocus
                  required
                />           
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  >
                  <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                </button>
               
        </div> 

             
            
        <div className="input-group mb-3">          
              <button type='submit' className="form-control btn btn-success" id="myBtn">Login&nbsp;&nbsp;&nbsp;<i class="fa fa-sign-in" aria-hidden="true"></i></button>        
              
        </div>
        
        </form>

      
        <div className="text-center">
          <Link to="/Frmforgotten" className="text-primary text-decoration-underline">
            Forgotten password?
          </Link>
        </div>
      


        {txthandleerror !== '' ? (<p className='text-danger'>{txthandleerror}</p>) : ''}
      </div>
    
    </div>
  </div>

  <div className="col-sm-4">        
  </div>


</div>

</div>
  )
}

export default Login